import React, { useState, useRef, useEffect } from 'react';

import dabangBridge from '~/utils/bridge';

import BG from '~/components/background';

import img_1 from './images/01.png';
import img_2 from './images/02.png';
import img_3 from './images/03.png';
import img_4 from './images/04.png';
import img_5 from './images/05.png';
import img_6 from './images/06.png';
import img_7 from './images/07.png';
import img_8 from './images/08.png';
import img_9 from './images/09.png';

import { Wrap, ButtonWrap } from './styled';

function DabangBannerComponent() {
  const [height, setHeight] = useState('');
  const _lastWrap = useRef(null);
  const _btnWrap = useRef(null);

  useEffect(() => {
    if (_lastWrap.current && _btnWrap.current && height === '') {
      const height = _lastWrap.current.getBoundingClientRect().height;
      const height2 = _btnWrap.current.getBoundingClientRect().height;

      setHeight(`${height + height2}px`);
    }
  }, [_lastWrap.current, _btnWrap.current]);

  function goSignRoomList() {
    const params = {
      api_type: 'BBOX',
      location: JSON.stringify([[125.38564393561512,32.320189184386535],[129.9669425751472,38.85305442043736]]),
      zoom: 9,
    };

    dabangBridge.web(call => {
      console.log('web');
      window.location.href = `https://dabangapp.com/search/map?filters=%7B%22multi_room_type%22%3A%5B0%2C1%2C2%5D%2C%22selling_type%22%3A%5B0%2C1%2C2%5D%2C%22deposit_range%22%3A%5B0%2C999999%5D%2C%22price_range%22%3A%5B0%2C999999%5D%2C%22trade_range%22%3A%5B0%2C999999%5D%2C%22maintenance_cost_range%22%3A%5B0%2C999999%5D%2C%22room_size%22%3A%5B0%2C999999%5D%2C%22supply_space_range%22%3A%5B0%2C999999%5D%2C%22room_floor_multi%22%3A%5B1%2C2%2C3%2C4%2C5%2C6%2C7%2C-1%2C0%5D%2C%22division%22%3Afalse%2C%22duplex%22%3Afalse%2C%22room_type%22%3A%5B1%2C2%5D%2C%22use_approval_date_range%22%3A%5B0%2C999999%5D%2C%22parking_average_range%22%3A%5B0%2C999999%5D%2C%22household_num_range%22%3A%5B0%2C999999%5D%2C%22parking%22%3Afalse%2C%22short_lease%22%3Afalse%2C%22full_option%22%3Afalse%2C%22built_in%22%3Afalse%2C%22elevator%22%3Afalse%2C%22balcony%22%3Afalse%2C%22safety%22%3Afalse%2C%22pano%22%3Afalse%2C%22is_contract%22%3Atrue%2C%22deal_type%22%3A%5B0%2C1%5D%7D&position=%7B%22location%22%3A%5B%5B126.2728908%2C37.1952243%5D%2C%5B127.7560451%2C37.792317%5D%5D%2C%22center%22%3A%5B127.01446798508894%2C37.494367328004216%5D%2C%22zoom%22%3A11%7D&search=%7B%22id%22%3A%22%22%2C%22type%22%3A%22%22%2C%22name%22%3A%22%22%7D&tab=all`;
    });

    dabangBridge.android(call => {
      console.log('android');
      call.signRoomList(JSON.stringify(params));
    });

    dabangBridge.ios(call => {
      call.callHandler('ObjC Echo', {
        cmd: 'signRoomList',
        params: params,
      });
    });
  }

  return (
    <Wrap>
      <BG width={750} height={1150} imgUrl={img_1} />
      <BG width={750} height={1056} imgUrl={img_2} />
      <BG width={750} height={1088} imgUrl={img_3} />
      <BG width={750} height={1088} imgUrl={img_4} />
      <BG width={750} height={264} imgUrl={img_5} />
      <BG width={750} height={1016} imgUrl={img_6} />
      <BG width={750} height={1152} imgUrl={img_7} />
      <div ref={_lastWrap} style={{ height }}>
        <BG width={750} height={1168} imgUrl={img_8} />
      </div>
      <ButtonWrap ref={_btnWrap} onClick={goSignRoomList}>
        <BG width={750} height={208} imgUrl={img_9} />
      </ButtonWrap>
    </Wrap>
  );
}

export default DabangBannerComponent;
